import { Event, Institution, InstitutionGroup, UserSimpleView } from 'cb-model';
import { Entity } from 'gossamer-unified';

interface ConvoEntityAndKey {
  entity: Entity<any>;
  key: string;
  icon: string;
}

export const getRelevantUserId = (createdBy: string, recipientUserId: string, currentUserId: string): string => {
  return createdBy === currentUserId ? recipientUserId : createdBy;
};

export const getConvoContextInfo = (forumType: string, forumKey: string, userId: string): ConvoEntityAndKey => {
  if (forumType === 'Event' || forumType === 'EventHost') {
    return {
      entity: Event,
      key: forumKey,
      icon: '/assets/icons/calendar.svg',
    };
  } else if (forumType === 'Institution') {
    return {
      entity: Institution,
      key: forumKey,
      icon: '/assets/icons/building-library.svg',
    };
  } else if (forumType === 'InstitutionGroup') {
    return {
      entity: InstitutionGroup,
      key: forumKey,
      icon: '/assets/icons/squares2x2.svg',
    };
  } else if (forumType === 'User') {
    return {
      entity: UserSimpleView,
      key: forumKey,
      icon: '/assets/icons/user.svg',
    };
  } else {
    return {
      entity: UserSimpleView,
      key: userId,
      icon: '/assets/icons/user.svg',
    };
  }
};
